<template>
  <div>
    <div class="container">
      <el-form label-position="left" label-width="90px" size="mini">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input class="input-width" placeholder="请输入订单号" v-model="params.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="买家手机号">
              <el-input class="input-width" placeholder="请输入买家手机号" v-model="params.delivermobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单类型">
              <el-select v-model="params.ordertype" placeholder="请选择订单类型">
                <el-option label="全部" :value="0"> </el-option>
                <el-option label="团购订单" :value="1"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否分销">
              <el-select v-model="params.isprofitsharing" placeholder="请选择订单类型">
                <el-option label="全部" :value="0"> </el-option>
                <el-option label="非分销" :value="1"> </el-option>
                <el-option label="分销单" :value="2"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="下单时间">
              <el-date-picker :picker-options="pickerOptions" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" unlink-panels v-model="params.time"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button @click="onClickFilter" size="small">筛选</el-button>
      <el-button @click="onClickClearFilter" style="color:#4E759E;" size="small" type="text">清空筛选条件</el-button>
    </div>

    <div class="container">
      <comp-tab :data="tabs" v-model="params.status" />
    </div>
    <div class="container">
      <div class="item" :key="data.id" v-for="data in list">
        <div class="order-detail">
          <div>
            <span class="order-detail_text">{{ data.id }}</span>
            <span class="invoice m10" v-if="data.groupuuid">{{ '拼团 ID: ' + data.groupuuid + ' ' + (data.grouplead === 2 ? '团长代收' : '单独发货') }}</span>
            <span class="invoice m10" v-if="data.needinvoice">需要开发票</span>
          </div>
          <div>
            <span class="order-detail_text m10">{{ data.user.nickname }} {{ data.user.mobile }}</span>
            <span class="member-tag" style="padding: 0 4px;" v-if="data.user.isvip === 2">会员</span>
            <span class="order-detail_text m10">{{ new Date(data.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</span>
            <el-button @click="$router.push({ name: 'order-detail', query: { id: data.id } })" size="small" type="text">查看详情</el-button>
          </div>
        </div>
        <div class="table">
          <div class="products">
            <div class="product" :key="oproduct.id" v-for="oproduct in data.orderproductsList">
              <div class="product-info">
                <div class="product-img">
                  <comp-imger :src="oproduct.product.imagesList.length ? oproduct.product.imagesList[0] : ''" />
                </div>
                <div>
                  <div class="product-name">{{ oproduct.product.name }}</div>
                  <div class="product-desc">{{ oproduct.optionname && '(' + Object.values(JSON.parse(oproduct.optionname)).join(', ') + ')' }}</div>
                </div>
              </div>
              <div class="price">{{ $amount1(oproduct.amount) }} 元</div>
              <div class="count">{{ oproduct.quantity }} 个</div>
            </div>
          </div>
          <div class="action">
            <span class="action-text">{{ map[data.status] || '非此类型商城该有状态' }}</span>
            <el-button @click="updateOrder(data, 2)" size="small" type="text" v-if="data.status == 12">拒绝退款</el-button>
            <el-button @click="updateOrder(data, 3)" size="small" type="text" v-if="data.status == 2">发货</el-button>
            <el-button @click="updateOrder(data, 8)" size="small" type="text" v-if="data.status == 12">同意退款</el-button>
            <el-button @click="updateOrder(data, 8)" size="small" type="text" v-if="data.status == 2">缺货直接退款</el-button>
            <el-button @click="updateOrder(data, 8)" size="small" type="text" v-if="data.status == 7">收到退货确认退款</el-button>
            <el-button @click="updateOrder(data, 7)" size="small" type="text" v-if="data.status == 9">同意退货</el-button>
            <el-button @click="updateOrder(data, 10)" size="small" type="text" v-if="data.status == 9">拒绝退货</el-button>
            <el-button @click="updateOrder(data, 11)" size="small" type="text" v-if="data.status == 7">未收到退货等因素拒绝退款</el-button>
          </div>
        </div>

        <el-dialog :visible.sync="dialogFormVisible" title="确认发货" width="400px">
          <el-form label-width="80px" size="small">
            <el-form-item label="物流公司">
              <el-select placeholder="请选择物流公司" v-model="shipindex">
              <el-option :key="index" :label="item.deliveryname + '-' + item.servicename+'-' + item.bizid" :value="index" v-for="(item, index) in shiplist"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="dialog-footer" slot="footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button :disabled="shipindex === null" @click="updateOrderShipping" type="primary">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div v-if="!list.length" class="list-nodata">
        <div class="fs">暂无数据</div>
      </div>

      <div v-if="list.length" class="table-bottom" style="margin-bottom:10px;">
        <el-button v-if="hasMore" :loading="loadmore" @click="getOrders" size="small" type="primary">加载更多</el-button>
        <p v-else style="color: #ccc; font-size: 12px;">已加载全部，没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import tab from '../../../components/tab/index.vue';
import { M, invoke } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};

const map = {
  '0': '等待买家支付',
  '1': '拼团中',
  '2': '待发货',
  '3': '等待买家收货',
  '4': '买家已收货',
  '5': '团购失败',
  '6': '买家已取消订单',
  '7': '退货中',
  '8': '已退款',
  '9': '买家申请退货',
  '10': '拒绝买家退货',
  '11': '同意退货但拒绝退款',
  '12': '买家申请退款'
};
export default {
  components: {
    'comp-tab': tab
  },
  name: 'order-list',
  watch: {
    'params.status': function() {
      this.list = [];
      this.getOrders();
    }
  },
  data() {
    return {
      tabs: [{ label: '全部订单', value: -1 }, { label: '未支付', value: 0 }, { label: '拼团中', value: 1 }, { label: '待发货', value: 2 }, { label: '待收货', value: 3 }, { label: '已收货', value: 4 }, { label: '团购失败', value: 5 }, { label: '申请退款', value: 12 }, { label: '申请退货', value: 9 }, { label: '已取消', value: 6 }],
      pickerOptions,
      dialogFormVisible: false,
      list: [],
      params: {
        id: '',
        status: -1,
        statuslistList: null,
        idlessthan: 0,
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        sortby: 1,
        sort: 1,
        deliverkind: 0,
        desk: '',
        daynumber: '',
        count: 20,
        delivermobile: '',
        isgroup: 0,
        issubscription: 0,
        isprofitsharing: 0,

        ordertype: 0,
        time: []
      },
      shippingrow: null,
      shiplist: [],
      shipindex: null,
      loadmore: false,
      hasMore: true,
      map
    };
  },
  created() {
    this.token = getToken();
    rpc(
      'StoreDeliveryService.GetOrderWxDeliveryList',
        M('Token', { token: this.token })
    ).then(res => {
      this.shiplist = res.wxdeliverylistList;
    });
    this.getOrders();

    this.conn = null;
    const listen = () => {
      if (this.conn === -1) {
        return;
      }
      this.conn = invoke(
        'StoreNotificationService.GetNotification',
        M('Token', { token: this.token }),
        async res => {
          if (res.kind !== 1) {
            return;
          }
          var item = res.order;
          const reslist = await Promise.all([
            rpc1(
              'StoreUserService.GetUser',
              M('IDWithTokenRequest', {
                token: M('Token', { token: this.token }),
                id: item.userid
              })
            ),
            rpc1(
              'StoreProductService.GetProductList',
              M('ProductListQueryRequest', {
                token: M('Token', { token: this.token }),
                idlistList: item.orderproductsList.map(v => v.productid),
                sortby: 1,
                sort: 1,
                count: item.orderproductsList.map(v => v.productid).length
              })
            )
          ]);
          item.user = reslist[0];
          item.orderproductsList.forEach(item1 => {
            item1.product = reslist[1].productlistList.find(v => v.id === item1.productid);
          });
          this.list.splice(0, 0, item);
        },
        e => {
          console.log(e);
          setTimeout(listen, 2000);
        }
      );
    };
    listen();
  },
  beforeDestroy() {
    this.conn.close();
    this.conn = -1;
  },
  methods: {
    // 订单列表
    async getOrders() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.createdatgreaterthan = 0;
      this.params.createdatlessthan = 0;
      if (this.params.time.length === 2) {
        this.params.createdatgreaterthan = parseInt(this.params.time[0].getTime() / 1000);
        this.params.createdatlessthan = parseInt(this.params.time[1].getTime() / 1000);
      }
      this.params.isgroup = 0;
      if (this.params.ordertype != 0) {
        if (this.params.ordertype == 1) {
          this.params.isgroup = 1;
        }
      }
      // 根据手机号获取用户id
      if (this.params.delivermobile) {
        const res = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.delivermobile,
            count: 1,
            order: 0
          })
        );
        this.params.userid = res.userlistList.length ? res.userlistList[0].id : 0;
      }
      // 获取订单列表
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreOrderService.GetOrderList',
        M('OrderListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      if (res.orderlistList.length === 0) {
        this.loadmore = false;
        this.hasMore = false;
        return;
      }
      // 完善订单列表里的关联资源
      const useridlist = res.orderlistList.map(item => item.userid);
      const productidlist = [];
      res.orderlistList.forEach(item => {
        item.orderproductsList.forEach(item1 => {
          productidlist.push(item1.productid);
        });
      });
      const reslist = await Promise.all([
        rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: useridlist,
            count: useridlist.length,
            order: 0
          })
        ),
        rpc(
          'StoreProductService.GetProductList',
          M('ProductListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: productidlist,
            sortby: 1,
            sort: 1,
            count: productidlist.length
          })
        )
      ]);
      res.orderlistList.forEach(item => {
        item.user = reslist[0].userlistList.find(v => v.id === item.userid);
        item.orderproductsList.forEach(item1 => {
          item1.product = reslist[1].productlistList.find(v => v.id === item1.productid);
        });
      });
      this.list = this.list.concat(res.orderlistList);
      this.hasMore = res.orderlistList.length;
      this.loadmore = false;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
    },

    updateOrder(row, status) {
      row = JSON.parse(JSON.stringify(row));
      if (status == 3) {
        this.shippingrow = row;
        this.dialogFormVisible = true;
        return;
      }
      row.status = status;
      rpc(
        'StoreOrderService.UpdateOrder',
        M('OrderWithTokenRequest', {
          token: M('Token', { token: this.token }),
          order: M('Order', {
            ...row,
            address: M('Address', row.address),
            invoice: M('Invoice', row.invoice),
            orderproductsList: row.orderproductsList.map(v => M('OrderProduct', v))
          })
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, row);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },
    updateOrderShipping() {
      const row = JSON.parse(JSON.stringify(this.shippingrow));
      row.status = 3;
        row.shippingcompany = this.shiplist[this.shipindex].deliveryname + '-' + this.shiplist[this.shipindex].servicename;
      rpc(
        'StoreOrderService.UpdateOrder',
        M('OrderWithTokenRequest', {
          token: M('Token', { token: this.token }),
          order: M('Order', {
            ...row,
            address: M('Address', row.address),
            invoice: M('Invoice', row.invoice),
            orderproductsList: row.orderproductsList.map(v => M('OrderProduct', v))
          }),
          ...this.shiplist[this.shipindex]
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, row);
        this.dialogFormVisible = false;
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },

    onClickFilter() {
      this.list = [];
      this.getOrders();
    },
    onClickClearFilter() {
      this.params = {
        id: '',
        status: -1,
        statuslistList: null,
        idlessthan: 0,
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        sortby: 1,
        sort: 1,
        deliverkind: 0,
        desk: '',
        daynumber: '',
        count: 20,
        delivermobile: '',
        isgroup: 0,
        issubscription: 0,

        ordertype: 0,
        time: []
      };
      this.list = [];
      this.getOrders();
    }
  }
};
</script>

<style scoped>
.input-width {
  width: 170px;
}
.list-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  color: #999;
}
.list-tabs {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.el-select {
  width: 100%;
}
.item {
  margin-bottom: 10px;
}
.item:last-child {
  margin-bottom: none;
}
.order-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 5px 10px;
}

.table {
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
}
.products {
  flex: 1;
  border-right: 1px solid #e9e9e9;
}
.action {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.action-text {
  font-size: 14px;
  color: #666;
  padding-bottom: 10px;
}
.invoice {
  background-color: #e9e9e9;
  color: #4ba3dd;
  font-size: 12px;
  padding: 3px;
  border-radius: 3px;
}
.order-detail_text {
  color: #666;
  font-size: 14px;
}
.m10 {
  margin: 0 10px;
}
.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.product {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
}
.product:last-child {
  border-bottom: none;
}
.product-info {
  padding: 10px;
  display: flex;
  flex: 1;
}
.product-img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  & > img {
    width: 80px;
    height: 80px;
  }
}
.product-name {
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.product-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
.price,
.count {
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e9e9e9;
}
</style>
